import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createBrtaRegistration,
  getBrtaRegistration,
  getBrtaRegistrations,
  editBrtaRegistration,
  deleteBrtaRegistration,
} from "api/brtaRegistrationApi";

import { BRTA_CODES_QUERY_KEY } from "hooks/brtaCodeHook";

export const BRTA_REGISTRATIONS_QUERY_KEY = "brta-registrations";

export const useBrtaRegistrations = (params = {}) => {
  return useQuery({
    queryKey: [BRTA_REGISTRATIONS_QUERY_KEY, params],
    queryFn: () => getBrtaRegistrations(params),
    keepPreviousData: true,
  });
};

export const useBrtaRegistration = id => {
  return useQuery({
    queryKey: [BRTA_REGISTRATIONS_QUERY_KEY, id],
    queryFn: () => getBrtaRegistration(id),
    enabled: !!id,
  });
};

export const useCreateBrtaRegistration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBrtaRegistration,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_REGISTRATIONS_QUERY_KEY]);
        queryClient.invalidateQueries([BRTA_CODES_QUERY_KEY]);
      }
    },
  });
};

export const useEditBrtaRegistration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editBrtaRegistration,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_REGISTRATIONS_QUERY_KEY]);
        queryClient.invalidateQueries([BRTA_CODES_QUERY_KEY]);
      }
    },
  });
};

export const useDeleteBrtaRegistration = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBrtaRegistration,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_REGISTRATIONS_QUERY_KEY]);
      }
    },
  });
};
